import * as React from 'react';
import clsx from 'clsx';
import { CasesByAdminLawyer, Category } from '@/interfaces';
import { Badge, Typography } from '@/components/common';

interface CasesListComponentProps {
	cases: CasesByAdminLawyer[] | undefined;
	classNameCard?: string;
}

interface CasesListType {
	id: string;
	category: Category;
	title: string;
}

export const CasesListComponent: React.FC<CasesListComponentProps> = ({
	cases,
	classNameCard,
}) => {
	const [casesList, setCasesList] = React.useState<CasesListType[]>();

	React.useEffect(() => {
		if (cases) {
			const caseAuxList: CasesListType[] = [];
			cases.forEach((item) => {
				caseAuxList.push({
					id: item.id,
					category: item.category_name,
					title: item.title,
				});
			});
			setCasesList(caseAuxList);
		}
	}, [cases]);

	return (
		<div className="lg:w-[656px] mr-2">
			<ul>
				{casesList &&
					casesList.map((caseCurrent) => (
						<li
							key={'case-' + caseCurrent.id}
							className={clsx(
								'bg-grey-5 p-4 rounded-xl mb-3 text-left',
								classNameCard
							)}
						>
							<Badge type={caseCurrent.category} size="small" />
							<Typography type="regular-16" className="mt-2">
								{caseCurrent.title}
							</Typography>
						</li>
					))}
			</ul>
		</div>
	);
};
